import React from 'react';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const NavTabs = ({ itens }) => {
    return (
          <Tabs>
            <TabList>
              {itens.map(item => (
                <Tab>{item.name}</Tab>
              ))}
            </TabList>

            {itens.map(item => (
              <TabPanel>
                {item.content}
              </TabPanel>
            ))}
          </Tabs>
    )
}

export default NavTabs;
